import React from 'react';
import '../components/styles/ProductPage.css';
import { FaRegFrown } from "react-icons/fa";
import {useLocation, useNavigate} from "react-router-dom";

const ProductPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [products, setProducts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [error, setError] = React.useState(null);
    const categories = ['전체', '베스트', '신상품', '프론트', '백엔드', '마케팅', '기타', '할인상품'];
    const [activeCategory, setActiveCategory] = React.useState('전체');
    const sortOptions = ['인기순',  '후기순', '금액 낮은 순', '금액 높은 순'];
    const [sortOption, setSortOption] = React.useState('인기순');

    React.useEffect(() => {
        // 카테고리 정보 받아오기
        if (location.state) {

            if (location.state === 'NCOMPANY' || location.state === 'KCOMPANY') {
                setActiveCategory('전체');
            } else{
                setActiveCategory(categoryEnum2[location.state]);
            }

        }

        const getProductList = async () => {
            try {
                const response = await fetch("/api/items", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });

                const data = await response.json();
                if (response.ok) {
                    setProducts(data.items);
                    setLoading(false);
                } else {
                    setError(data.message || "상품 데이터를 불러올 수 없습니다.");
                    setLoading(false);
                }
            } catch (err) {
                setError("데이터 로딩 중 오류가 발생했습니다.");
                setLoading(false);
            }
        };

        getProductList();
    }, []);

    const getProductDetail = (itemId) => {
        navigate(`/products/${itemId}`);
        window.scrollTo(0, 0);
    };

    const categoryEnum = {
        '베스트': 'BEST',
        '신상품': 'NEW',
        '프론트': 'NCOMPANY',
        '백엔드': 'KCOMPANY',
        '마케팅': 'MARKETING',
        '기타': 'ETC',
        '할인상품': 'DISCOUNTED'
    };

    const categoryEnum2 = {
        'BEST': '베스트',
        'NEW': '신상품',
        'NCOMPANY': '프론트',
        'KCOMPANY': '백엔드',
        'MARKETING': '마케팅',
        'ETC': '기타',
        'DISCOUNTED': '할인상품'
    }

    // 카테고리 필터링
    const filteredProducts = activeCategory === '전체'
        ? products
        : products.filter(product => product.category === categoryEnum[activeCategory]);

    // 정렬 함수
    const sortedProducts = React.useMemo(() => {
        let sorted = [...filteredProducts];
        switch (sortOption) {
            case '인기순':
                sorted.sort((a, b) => b.rating - a.rating); // 예: popularity 필드
                break;
            // case '가격순':
            case '금액 낮은 순':
                sorted.sort((a, b) => a.salePrice - b.salePrice);
                break;
            case '금액 높은 순':
                sorted.sort((a, b) => b.salePrice - a.salePrice);
                break;
            case '후기순':
                sorted.sort((a, b) => b.reviewCount - a.reviewCount); // 예: reviewCount 필드
                break;
            default:
                break;
        }
        return sorted;
    }, [filteredProducts, sortOption]);

    if (loading) return <div>상품 목록을 불러오는 중...</div>;
    if (error) return <div>Error: {error}</div>;

    return (
        <div className="product-page mt-[200px]">
            <h1 className="page-title">제품</h1>
            <div className="category-bar">
                {categories.map((category, index) => (
                    <button
                        key={index}
                        className={`category-button ${activeCategory === category ? 'active' : ''}`}
                        onClick={() => setActiveCategory(category)}
                    >
                        {category}
                    </button>
                ))}
            </div>
            <div className="sort-bar">
                {sortOptions.map((option, index) => (
                    <button
                        key={index}
                        className={`sort-button ${sortOption === option ? 'active' : ''}`}
                        onClick={() => setSortOption(option)}
                    >
                        {option}
                    </button>
                ))}
            </div>

            {sortedProducts.length === 0 ?
                <div className="no-product-container">
                    <div className="no-product-image">
                        <FaRegFrown size={100} color="#6C95FF"/>
                    </div>
                    <div className="no-product-content">
                        <p className="no-product-description">현재 판매중인 상품이 없습니다.</p>
                    </div>
                </div>
                :
                <div className="product-grid">
                    {sortedProducts.map((product, index) => (
                        <div key={index} className="product-card relative" role="button" onClick={() => getProductDetail(product.itemId)}>
                            {product.category === 'DISCOUNTED' && (
                                <div className="discount-badge absolute top-3 left-3 bg-red-500 text-white px-3 py-1 rounded-full shadow-md text-sm font-semibold z-10 animate-pulse">
                                    할인상품
                                </div>
                            )}
                            <div className="product-image">
                                {product.thumbFileName && product.thumbPath ? (
                                    <img src={product.thumbPath || "/placeholder.svg"} alt={product.itemName} className="w-full h-full object-cover rounded-xl" />
                                ) : (
                                    <div className="w-full h-full bg-gray-200 flex items-center justify-center rounded-xl">
                                        <span className="text-gray-400">No Image</span>
                                    </div>
                                )}
                            </div>
                            <h2 className="product-title mt-2 font-semibold text-lg">{product.itemName}</h2>
                            <p className="product-description text-gray-600 text-sm">{product.itemDescription}</p>
                            <p id="product-original-price" className="line-through text-gray-400">{product.costPrice?.toLocaleString()}원</p>
                            <div className="product-price-grid-main flex items-center justify-between mt-1">
                                <p className="product-discount-rate text-red-500 font-bold">{product.discountRate}%</p>
                                <p className="product-price text-lg font-semibold text-gray-800"><span className="text-xl"> </span>{product.salePrice?.toLocaleString()}원</p>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
};

export default ProductPage;
